const menunav = [
{
  name: 'modify',
	path: '/modify',
  component: () => import('@/view/modify'),
  meta: {
    title: '修改密码'
  }
}]
export default menunav
